import { type MCPServerInfo } from '../../types';

const GleanServer: MCPServerInfo = {
  serverId: 'GLEAN',
  name: 'Glean',
  slug: 'glean',
  description:
    "Search enterprise knowledge, read documents, search people, and chat with Glean's AI assistant.",
  source: {
    sourceType: 'DYNAMIC_REMOTE_URL',
    mcpServerUrl: 'https://{gleanInstanceUrl}/mcp/default',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: ['gleanInstanceUrl'],
    properties: {
      gleanInstanceUrl: {
        type: 'string',
        description: 'Glean backend hostname (e.g. your-company-be.glean.com)',
        sensitive: false,
        isUrlParameter: true
      }
    }
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default GleanServer;
